<template>
  <section class="sidebar-layout">
    <div class="left">
      <el-menu default-active="2" class="el-menu-vertical-demo">
        <el-menu-item
          v-for="item in tabs"
          :index="item.routeName"
          :key="item.routeName"
          @click="handleTab(item)"
          :class="$route.path === item.path ? 'is-active' : ''"
        >
          <i class="el-icon-menu"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      tabs: [
        {
          name: "产品",
          routeName: "ProductsList",
          path: "/product/list",
          disabled: false,
        },
        {
          name: "系列",
          routeName: "ProductSeriesList",
          path: "/product/series/list",
          disabled: false,
        },
        {
          name: "规格",
          routeName: "ProductSpecificationsList",
          path: "/product/specifications/list",
          disabled: false,
        },

        {
          name: "色系",
          routeName: "ProductColorsList",
          path: "/product/colors/list",
          disabled: false,
        },
        {
          name: "尺寸",
          routeName: "ProductlLengthwidthList",
          path: "/product/length_width/list",
          disabled: false,
        },
        {
          name: "厚度",
          routeName: "ProductThicknessesList",
          path: "/product/thicknesses/list",
          disabled: false,
        },

        {
          name: "效果",
          routeName: "ProductEffectsList",
          path: "/product/effects/list",
          disabled: false,
        },
        {
          name: "用途",
          routeName: "ProductUsagesList",
          path: "/product/usages/list",
          disabled: false,
        },
        {
          name: "型号",
          routeName: "ProductModelsList",
          path: "/product/models/list",
          disabled: false,
        },
        {
          name: "优势",
          routeName: "ProductAdvantagesList",
          path: "/product/advantages/list",
          disabled: false,
        },
      ],
    };
  },
  methods: {
    handleTab(item) {
      this.$router.push({
        name: item.routeName,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom-variables.scss";
.sidebar-layout {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .left {
    flex: 120px 0 0;
    height: 100%;
    background-color: #fff;
  }
  .right {
    flex: 1 0 0;
    height: 100%;
    overflow: hidden;
  }
}
.is-active {
  outline: none;
  background-color: #f1f1f1 !important;
  color: $custom-menu-hover-color !important;
}
</style>
